import * as React from 'react';

function LifebeltIcon(props) {
	return (
		<svg width={16} height={23} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M4.314 3.64a3.64 3.64 0 0 0 7.28 0A3.644 3.644 0 0 0 7.954 0a3.644 3.644 0 0 0-3.64 3.64ZM1.998 9.682c1.182-.845 2.644-1.295 4.224-1.295h3.464c1.58 0 3.043.45 4.224 1.295 1.291.926 1.998 2.127 1.998 3.384v4.03a2.145 2.145 0 0 1-2.14 2.144h-.285l-.323 1.918a1.975 1.975 0 0 1-.247.674h1.434c.26 0 .474.213.474.474s-.213.475-.474.475H1.56a.476.476 0 0 1-.474-.475c0-.26.213-.474.474-.474h1.433a1.973 1.973 0 0 1-.246-.674l-.323-1.918H2.14A2.145 2.145 0 0 1 0 17.097v-4.03c0-1.258.707-2.458 1.998-3.384Zm.703 5.458.982 5.861a.99.99 0 0 0 .982.83h6.578a.99.99 0 0 0 .982-.83l.983-5.86a.994.994 0 0 0-.982-1.159H3.683A.994.994 0 0 0 2.7 15.14Z'
				fill='#153c4f'
			/>
		</svg>
	);
}

export default LifebeltIcon;
